export default "__VITE_ASSET__CwESMEFs__"